"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Templates: true,
  Outros: true,
  PhotoAnimations: true,
  PhotoTransitions: true,
  Fonts: true
};
Object.defineProperty(exports, "Templates", {
  enumerable: true,
  get: function get() {
    return _all.Templates;
  }
});
Object.defineProperty(exports, "Outros", {
  enumerable: true,
  get: function get() {
    return _all.Outros;
  }
});
Object.defineProperty(exports, "PhotoAnimations", {
  enumerable: true,
  get: function get() {
    return _all.PhotoAnimations;
  }
});
Object.defineProperty(exports, "PhotoTransitions", {
  enumerable: true,
  get: function get() {
    return _all.PhotoTransitions;
  }
});
Object.defineProperty(exports, "Fonts", {
  enumerable: true,
  get: function get() {
    return _fonts.default;
  }
});

var _all = require("animations-json/build/all");

var _fonts = _interopRequireDefault(require("./config/fonts.json"));

var _utils = require("./utils");

Object.keys(_utils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _utils[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _utils[key];
    }
  });
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }